import { gql } from '@apollo/client';
import List from './List';
import Show from './Show';

export default {
  name: 'professionalScreenings',
  inputShow: gql`
    query professionalScreenings($input: ProfessionalScreeningQueryInput) {
      professionalScreenings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Professional Screenings',
  },
};
